export const PPLogo = ({ size = 20, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true" focusable="false">
    <circle cx="12" cy="12" r="10.5" stroke="currentColor" strokeWidth="1.5" />
    <text x="12" y="15.5" fill="currentColor" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="10" fontWeight="800">PP</text>
  </svg>
);
